// extracted by mini-css-extract-plugin
export default {"applicableFeeDetails":"_2EvjVVvbj3CEsWP_5zuPGY"};